module.exports = __webpack_public_path__ + "img/J11872.9e541b26.png";